<template>
  <order-list :is-order-status="10"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Paid',
  components: {
    OrderList
  }
}
</script>
